import { useEffect } from 'react';
import { useFeatureFlags } from '@/providers/FeatureFlagProvider';
import { SecurityMonitor } from '@/utils/security';
import { useFocusMusic } from '@/hooks/useFocusMusic';

// Lightweight, read-only smoke tests to detect obvious breakages without affecting UX
const NoBreakageSmokeTests: React.FC = () => {
  const { flags } = useFeatureFlags();
  const focusMusic = useFocusMusic();

  useEffect(() => {
    if (!flags.ENABLE_SMOKE_TESTS) return;

    const run = async () => {
      const results: Record<string, boolean | string> = {};
      try {
        results['speechSynthesis_supported'] = typeof window !== 'undefined' && 'speechSynthesis' in window;
      } catch {
        results['speechSynthesis_supported'] = false;
      }

      try {
        results['focusMusic_context'] = !!focusMusic && typeof focusMusic.pause === 'function';
      } catch {
        results['focusMusic_context'] = false;
      }

      try {
        // Sanity check a core route element exists in DOM after routing
        results['app_root_present'] = !!document.getElementById('root');
      } catch {
        results['app_root_present'] = false;
      }

      console.groupCollapsed('[SmokeTests] No-breakage results');
      Object.entries(results).forEach(([k, v]) => console.log(`${k}:`, v));
      console.groupEnd();

      try {
        await SecurityMonitor.getInstance().logSecurityEvent('smoke_tests_results', { results });
      } catch {}
    };

    run();
  }, [flags.ENABLE_SMOKE_TESTS, focusMusic]);

  return null;
};

export default NoBreakageSmokeTests;
